import { render, staticRenderFns } from "./UpdateActions.vue?vue&type=template&id=774d1718&scoped=true&"
import script from "./UpdateActions.vue?vue&type=script&lang=js&"
export * from "./UpdateActions.vue?vue&type=script&lang=js&"
import style0 from "./UpdateActions.vue?vue&type=style&index=0&id=774d1718&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d1718",
  null
  
)

export default component.exports